import { render } from "./ReglesMenusPanneau.vue?vue&type=template&id=716cfbd4&scoped=true&ts=true"
import script from "./ReglesMenusPanneau.vue?vue&type=script&lang=ts"
export * from "./ReglesMenusPanneau.vue?vue&type=script&lang=ts"

import "./ReglesMenusPanneau.vue?vue&type=style&index=0&id=716cfbd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716cfbd4"]])

export default __exports__